<template>
  <div class="login-stat-page">
    <v-container fluid>
      <login-stat-filter @apply="fetchData" />
      <div class="text-caption grey--text mb-3">
        Данные обновляются раз в минуту (буфер Redis → таблица statistic_login).
      </div>

      <login-indicators-list class="mb-5" :indicators="indicators" :loading="isLoading" />

      <chart-container class="mb-5" :loading="isLoading" :no-data="!rows.length">
        <template #chart>
          <grouped-stack-bar-chart
            title="Отправлено → логины (по устройствам)"
            :labels="labels"
            :datasets="heroDatasets"
          />
        </template>
      </chart-container>

      <v-row>
        <v-col md="6" cols="12">
          <chart-container style="height: 100%" :loading="isLoading" :no-data="!rows.length">
            <template #chart>
              <login-rate-line-chart
                title="Login rate + порог"
                :labels="labels"
                :datasets="rateDatasets"
                :threshold="rateThreshold"
              />
            </template>
          </chart-container>
        </v-col>
        <v-col md="6" cols="12">
          <chart-container style="height: 100%" :loading="isLoading" :no-data="!rows.length">
            <template #chart>
              <grouped-stack-bar-chart
                title="Нагрузка: отправлено + заблокировано"
                :labels="labels"
                :datasets="loadDatasets"
              />
            </template>
          </chart-container>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6" cols="12">
          <chart-container style="height: 100%" :loading="isLoading" :no-data="!rows.length">
            <template #chart>
              <grouped-stack-bar-chart
                title="Каналы: SMS vs Flash-call"
                :labels="labels"
                :datasets="channelsDatasets"
                :threshold="channelsThreshold"
              />
            </template>
          </chart-container>
        </v-col>
        <v-col md="6" cols="12">
          <chart-container style="height: 100%" :loading="isLoading" :no-data="!rows.length">
            <template #chart>
              <grouped-stack-bar-chart
                title="Срез по устройствам"
                :labels="breakdown.labels"
                :datasets="breakdown.datasets"
                :options-override="{
                  scales: { x: { stacked: false }, y: { stacked: false, beginAtZero: true } },
                }"
              />
            </template>
          </chart-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import loginApi from '@/api/statistics/security/login'
  import ChartContainer from '@/components/stat/ChartContainer.vue'
  import LoginStatFilter from '@/components/stat/security/LoginStatFilter.vue'
  import LoginIndicatorsList from '@/components/stat/security/LoginIndicatorsList.vue'
  import GroupedStackBarChart from '@/components/stat/security/GroupedStackBarChart.vue'
  import LoginRateLineChart from '@/components/stat/security/LoginRateLineChart.vue'
  import {
    uniqueLabels,
    buildHeroDatasets,
    buildLoadDatasets,
    buildChannelsDatasets,
    buildRateDatasets,
    buildDeviceBreakdown,
  } from '@/util/statistics/login'

  export default {
    name: 'LoginStatistics',
    components: {
      ChartContainer,
      LoginStatFilter,
      LoginIndicatorsList,
      GroupedStackBarChart,
      LoginRateLineChart,
    },
    data () {
      return {
        isLoading: false,
        rows: [],
        indicators: {},
        rateThreshold: null,
        granularity: 'hour',
        deviceFilter: null,
        smsPerHour: {},
      }
    },
    computed: {
      labels () {
        return uniqueLabels(this.rows)
      },
      heroDatasets () {
        return buildHeroDatasets(this.rows, this.labels)
      },
      loadDatasets () {
        return buildLoadDatasets(this.rows, this.labels)
      },
      channelsDatasets () {
        return buildChannelsDatasets(this.rows, this.labels)
      },
      rateDatasets () {
        return buildRateDatasets(this.rows, this.labels)
      },
      breakdown () {
        return buildDeviceBreakdown(this.rows)
      },
      channelsThreshold () {
        if (this.granularity !== 'hour') return null
        const values = this.deviceFilter
          ? [this.smsPerHour[this.deviceFilter]]
          : Object.values(this.smsPerHour)
        const nums = values.filter((v) => typeof v === 'number')
        return nums.length ? Math.max(...nums) : null
      },
    },
    methods: {
      fetchData (filter) {
        this.isLoading = true
        this.granularity = filter.granularity
        this.deviceFilter = filter.deviceType || null
        Promise.all([loginApi.fetchIndicators(filter), loginApi.fetchDynamics(filter)])
          .then(([indicatorsRes, dynamicsRes]) => {
            this.indicators = indicatorsRes.data
            this.rows = dynamicsRes.items
            this.rateThreshold = dynamicsRes.thresholds ? dynamicsRes.thresholds.rateAlert : null
            this.smsPerHour = dynamicsRes.thresholds ? dynamicsRes.thresholds.smsPerHour : {}
          })
          .catch((err) => {
            this.rows = []
            this.indicators = {}
            this.showErrorFromResponse(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
    },
  }
</script>

<style lang="less" scoped>
@import '@/assets/styles/statistic.less';
</style>
